export { MainContentHeader } from './MainContentHeader'
export type { MainContentHeaderProps } from './MainContentHeader.types'
